import { localStorageApi } from '../localStorageApi'
import { isMobileAppMode, isLocalStorageMobileAppMode } from '../mode'

export const extractQueryParam = (paramKey) => {
	const queryString = window.location.search
	if (!queryString) {
		return null
	}
	const params = new URLSearchParams(queryString)
	return params.get(paramKey)
}

export const isClientMonitor = () => window.location.pathname === '/client-monitor'

export const isNativeAppMode = () => {
	return isMobileAppMode(extractQueryParam('appMode')) || isLocalStorageMobileAppMode()
}

export const isClientMonitorBrowserTest = () => {
	return !!localStorageApi.getItem('lp.clientDisplayBrowserTest')
}

export const setClientMonitorBrowserTest = (value) => {
	localStorageApi.setItem('lp.clientDisplayBrowserTest', value)
}

export const getClientMonitorBaseUrl = () => {
	if (window.REACT_APP_CLIENT_MONITOR_URL) {
		return window.REACT_APP_CLIENT_MONITOR_URL
	}
	if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
		return 'http://localhost:3001'
	}
	return window.location.origin
}

export const withSocketClientMonitor = () => {
	return !isNativeAppMode() && !isClientMonitorBrowserTest()
}

export const withJsClientMonitor = () => {
	return isNativeAppMode() || isClientMonitorBrowserTest()
}

export const setLocalStorageAccessToken = (accessToken) => {
	const accessTokenKey = isClientMonitor() ? 'accessTokenClientMonitor' : 'accessToken'
	localStorageApi.setItem(accessTokenKey, accessToken)
}

export const setLocalStorageRefreshToken = (refreshToken) => {
	const refreshTokenKey = isClientMonitor() ? 'refreshTokenClientMonitor' : 'refreshToken'
	localStorageApi.setItem(refreshTokenKey, refreshToken)
}

export const getLocalStorageRefreshToken = () => {
	const key = isClientMonitor() ? 'refreshTokenClientMonitor' : 'refreshToken'
	return  localStorageApi.getItem(key)
}

export const removeLocalStorageAccessToken = () => {
	const accessTokenKey = isClientMonitor() ? 'accessTokenClientMonitor' : 'accessToken'
	localStorageApi.removeItem(accessTokenKey)
}

export const removeLocalStorageRefreshToken = () => {
	const refreshTokenKey = isClientMonitor() ? 'refreshTokenClientMonitor' : 'refreshToken'
	localStorageApi.removeItem(refreshTokenKey)
}

export const removeLocalStorageAuthUuid = () => {
	localStorageApi.removeItem('authUuid')
}

export const removeLocalStorageGlobalModalData = () => {
	localStorageApi.removeItem('exhibitionNotificationModalDisable')
}

export const getAuthUuid = () => {
	return extractQueryParam('authUuid') || localStorageApi.getItem('authUuid')
}
